/**
 * RAKNIDA · Search Popular chips
 * Shows real popular search keywords:
 *  1) terms visitors actually searched (localStorage frequency)
 *  2) topped up with high-frequency catalogue terms (heritage / artist / space / tier)
 * All chips link to /search?q=…
 */
(function () {
  'use strict';

  var KEY = 'rk-popular-searches';
  var MAX_STORE = 40;
  var MAX_CHIPS = 6;

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function readStore() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .filter(function (x) {
          return x && typeof x.term === 'string' && x.term.trim();
        })
        .map(function (x) {
          return { term: String(x.term).trim(), count: Number(x.count) || 1 };
        });
    } catch (e) {
      return [];
    }
  }

  function writeStore(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORE)));
    } catch (e) {}
  }

  function recordSearch(term) {
    term = String(term || '').trim();
    if (!term || term.length < 2) return;
    var list = readStore().filter(function (x) {
      return x.term.toLowerCase() !== term.toLowerCase();
    });
    var prev = readStore().find(function (x) {
      return x.term.toLowerCase() === term.toLowerCase();
    });
    list.unshift({ term: term, count: (prev && prev.count ? prev.count : 0) + 1 });
    list.sort(function (a, b) {
      return b.count - a.count || a.term.localeCompare(b.term);
    });
    writeStore(list);
  }

  function topFromBlob(blob, limit) {
    var counts = {};
    String(blob || '')
      .split('|')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean)
      .forEach(function (t) {
        counts[t] = (counts[t] || 0) + 1;
      });
    return Object.keys(counts)
      .sort(function (a, b) {
        return counts[b] - counts[a] || a.localeCompare(b);
      })
      .slice(0, limit || MAX_CHIPS);
  }

  function catalogSeeds(root) {
    var dataEl = root.querySelector('[data-rk-search-catalog]');
    if (!dataEl) return [];
    var heritages = topFromBlob(dataEl.getAttribute('data-heritages'), 4);
    var artists = topFromBlob(dataEl.getAttribute('data-artists'), 3);
    var spaces = topFromBlob(dataEl.getAttribute('data-spaces'), 2);
    var tiers = topFromBlob(dataEl.getAttribute('data-tiers'), 2);
    // Prefer heritages, then artists, spaces, tiers — unique
    var out = [];
    function push(list) {
      list.forEach(function (t) {
        if (out.length >= MAX_CHIPS) return;
        if (
          out.some(function (x) {
            return x.toLowerCase() === t.toLowerCase();
          })
        )
          return;
        out.push(t);
      });
    }
    push(heritages);
    push(artists);
    push(spaces);
    push(tiers);
    return out;
  }

  function buildPopular(root) {
    var out = [];
    var seen = {};
    function add(term) {
      term = String(term || '').trim();
      if (!term || term.length < 2) return;
      var key = term.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(term);
    }

    readStore()
      .sort(function (a, b) {
        return b.count - a.count;
      })
      .forEach(function (x) {
        if (out.length < MAX_CHIPS) add(x.term);
      });

    catalogSeeds(root).forEach(function (t) {
      if (out.length < MAX_CHIPS) add(t);
    });

    return out;
  }

  function renderChips(root, terms) {
    var mount = root.querySelector('[data-rk-search-chips]');
    if (!mount) return;
    var label =
      mount.getAttribute('data-label') ||
      (mount.querySelector('.rk-search-chips-lbl') &&
        mount.querySelector('.rk-search-chips-lbl').textContent) ||
      'Popular:';
    if (!terms.length) {
      mount.hidden = true;
      return;
    }
    mount.hidden = false;
    var html =
      '<span class="rk-search-chips-lbl">' +
      label.replace(/</g, '&lt;') +
      '</span>';
    terms.forEach(function (term) {
      html +=
        '<a class="rk-search-chip" href="/search?q=' +
        encodeURIComponent(term) +
        '">' +
        String(term).replace(/</g, '&lt;') +
        '</a>';
    });
    mount.innerHTML = html;
  }

  function boot() {
    var root = document.querySelector('.rk-search');
    if (!root) return;

    var performed = root.getAttribute('data-search-performed') === 'true';
    var terms = root.getAttribute('data-search-terms') || '';
    if (performed && terms) recordSearch(terms);

    renderChips(root, buildPopular(root));
  }

  /* AJAX searches re-record + refresh chip ranking without a full reload */
  document.addEventListener('rk-search:performed', function (e) {
    var term = e && e.detail && e.detail.term;
    if (!term) return;
    recordSearch(term);
    var root = document.querySelector('.rk-search');
    if (root) renderChips(root, buildPopular(root));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

